var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h4', {
    staticClass: "main-header"
  }, [_vm._v(_vm._s(_vm.$t('navigation_gallery')))]), _c('GalleryOverView', {
    attrs: {
      "hiddenTags": _vm.hiddenTags,
      "isAllowedEdit": _vm.isAllowed('gallery_edit'),
      "isAllowedCSVDownload": _vm.isAvailable('gallery:csv_download')
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }